import React from 'react';

const HoverCollepseIcon = (props) => {
  return (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 2L15.1688 13.47C15.3714 13.7943 15.3714 14.2057 15.1688 14.53L8 26"
        stroke="#99A0AE"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default HoverCollepseIcon;
